import { render, staticRenderFns } from "./borrowAndReturnMobile.vue?vue&type=template&id=8da11aa8&scoped=true&"
import script from "./borrowAndReturnMobile.vue?vue&type=script&lang=js&"
export * from "./borrowAndReturnMobile.vue?vue&type=script&lang=js&"
import style0 from "./borrowAndReturnMobile.vue?vue&type=style&index=0&id=8da11aa8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da11aa8",
  null
  
)

export default component.exports